import React from 'react'

const LoadingSpinner: React.FC = () => {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-500"></div>
      <span className="ml-4 text-lg text-gray-600">載入中...</span>
    </div>
  )
}

export default LoadingSpinner
